import styled from "styled-components/macro";
import { Text } from "@ds/react";
import CustomDivider from "components/Footer/CustomDivider";
import { MAX_CONTENT_WIDTH } from "config/resolution";

export const Container = styled.div(({ theme: { breakpoint, color } }) => ({
  display: "flex",
  flexDirection: "column",
  margin: 0,
  backgroundColor: color.brandPrimary.light,
  padding: "40px 0",
  a: {
    fontSize: "20px",
  },

  "> *:first-child": {
    "> *:first-child": {
      marginBottom: "40px",
    },
  },

  [breakpoint.lg()]: {
    padding: "60px 0",

    "> *:first-child": {
      "> *:first-child": {
        marginBottom: "60px",
      },
    },
  },

  "> *": {
    padding: "0 16px",

    [breakpoint.lg()]: {
      padding: "0 36px",
    },

    [breakpoint.xl()]: {
      maxWidth: MAX_CONTENT_WIDTH,
      padding: "0 112px",
      margin: "auto",
    },
  },
}));

export const Section = styled.div(({ theme: { spacing, breakpoint } }) => ({
  display: "flex",
  flex: 1,
  flexDirection: "column",
  width: "100%",
  minHeight: "min-content",

  [breakpoint.xl()]: {
    flexDirection: "row",

    "> *": {
      marginRight: spacing.inline.md,

      ":last-child": {
        marginRight: 0,
      },
    },
  },
}));

export const Item = styled.div(({ theme: { spacing, breakpoint } }) => ({
  display: "inline-flex",
  flex: 1,
  width: "100%",
  boxSizing: "content-box",
  marginBottom: "40px",
  lineHeight: spacing.inline["xs"],

  ":last-child": {
    marginBottom: 0,
  },

  [breakpoint.xl()]: {
    marginBottom: 0,
  },
}));

export const Divider = styled(CustomDivider)(({ theme: { color } }) => ({
  width: "2px",
  height: "auto",
  backgroundColor: color.brandTertiary.light,
}));

export const Content = styled.div(() => ({
  width: "100%",
  marginLeft: "16px",

  "> *": {
    marginBottom: "16px",

    ":last-child": {
      marginBottom: 0,
    },
  },
}));

export const Block = styled.div(() => ({
  "> *": {
    marginBottom: "4px",

    "&.normal": {
      fontWeight: 500,
    },

    ":last-child": {
      marginBottom: 0,
    },
  },
}));

export const Title = styled(Text)(() => ({
  textTransform: "none",
}));

export const DevicesImgs = styled.picture(({ theme }) => ({
  marginLeft: "190px",

  [theme.breakpoint.lg()]: {
    display: "block",
  },
}));

export const ItemImg = styled.div(({ theme: { spacing, breakpoint } }) => ({
  display: "none",
  flex: 1,
  width: "100%",
  boxSizing: "content-box",
  marginBottom: "40px",
  lineHeight: spacing.inline["xs"],

  [breakpoint.xl()]: {
    marginBottom: 0,
    display: "inline-flex",
  },
}));

export const FirstItem = styled.div(({ theme: { spacing, breakpoint } }) => ({
  display: "inline-flex",
  flex: 1,
  width: "100%",
  boxSizing: "content-box",
  marginBottom: "0px",
  lineHeight: spacing.inline["xs"],

  ":last-child": {
    marginBottom: 0,
  },

  [breakpoint.lg()]: {
    marginBottom: 0,
  },
}));
